<div class="modal-content text-center">
    <div class="modal-header text-center">

        <button type="button" class="btn-close" (click)="cerrar()"></button>
    </div>
    <div class="modal-body pb-5">
        <img src="assets/img/user-white.svg">
        <h3 class="mt-2">{{escritorio.ejecutivo}}</h3>
        <hr class="w-75 mx-auto">
        <h3 class="">Excepción de fila</h3>
        <h6>Indique la Serie y Turno a para su atención</h6>
    </div>
    <div class="modal-footer">
        <div class="row  mx-auto text-center">
            <form [formGroup]="urgenteForm" (ngSubmit)="onSubmitExcepcion()">
                <div class="col-12">
                    <p>Serie</p>
                </div>
                <div class="col-10 offset-1 mb-4">
                    <div class="input-group">
                        <select formControlName="serie" class="text-center">
                          <option value="null" disabled>Seleccione serie</option>
                          <option *ngFor="let serie of emiStatus" [ngValue]="serie">{{serie.serie}}</option>
                        </select>
                    </div>
                    <div *ngIf="urgenteIsSubmitted && urgenteForm.get('serie')!.errors">
                        <div *ngIf="urgenteForm.get('serie')!.errors!.required">
                            <small class="text-danger">Debe seleccionar una serie.</small>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <p>Turno</p>
                </div>
                <div class="col-10 offset-1 mb-4 justify-content-center">
                    <div class="input-group  justify-content-center align-items-center">
                        <input type="text" class="form-control" id="turno" formControlName="turno" [ngClass]="{'is-invalid': urgenteIsSubmitted && urgenteForm.get('turno')!.errors}" class="w-25 text-center" />
                    </div>
                    <small>Coloque cero (0) si no se tiene un turno</small>
                    <div *ngIf="urgenteForm.controls['turno'].invalid && (urgenteForm.controls['turno'].dirty || urgenteForm.controls['turno'].touched)">
                        <small class="text-danger">Debe ingresar un valor válido.</small>
                    </div>
                    <div *ngIf="urgenteIsSubmitted && urgenteForm.get('turno')!.errors">
                        <div *ngIf="urgenteForm.get('turno')!.errors!.required">
                            <small class="text-danger">Por favor ingrese un valor válido.</small>
                        </div>
                    </div>
                </div>
                <div class="row mx-auto">
                    <div class="col-12 text-center">
                        <button type="button" class="btn-color" type="submit">GENERAR NUEVO TURNO</button>
                    </div>
                </div>
            </form>
            <div class="col-12 mt-4">
                <a type="button" (click)="cerrar()">Volver</a>
            </div>
        </div>
    </div>
</div>